export default "__VITE_ASSET__FF45BFXw__"